// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".newsletter-badge[data-v-80a1e3d8]{background-color:var(--primary);border-radius:150px/20px;border-top-left-radius:5px;border-top-right-radius:5px;box-shadow:5px 5px 10px 0 rgba(0,0,0,.25);color:var(--primary-text-color,var(--white));font-size:20px;font-weight:700;min-width:250px;overflow:hidden;padding:15px 10px 25px;text-align:center;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
